module.exports = __webpack_public_path__ + "img/play-button.33498ef8.svg";